<script>
exports.AssetsService = (api, handleError) => {
  const basePath = '/assets'
  const adminPath = `/admin${basePath}`

  const queryBuilder = (query = {}) => {
    let queryBuilder = []
    for (const key in query) {
      if (query[key]) {
        queryBuilder.push(`${key}=${query[key]}`)
      }
    }
    queryBuilder = queryBuilder.length ? '?' + queryBuilder.join('&') : ''
    return queryBuilder
  }

  const writeNote = async (data) => {
    try {
      return await api.post(`${adminPath}/notes/new`, data)
    } catch (error) {
      return handleError(error)(error)
    }
  }

  const updateNote = async (uid, data) => {
    try {
      return await api.put(`${adminPath}/notes/uid/${uid}`, data)
    } catch (error) {
      return handleError(error)(error)
    }
  }

  const getNotes = async ({ assetUid, pager, sort }) => {
    try {
      return await api.get(
        `${adminPath}/notes/uid/${assetUid}${queryBuilder({
          ...pager,
          sort
        })}`
      )
    } catch (error) {
      return handleError(error)(error)
    }
  }

  const exportExcel = async (filters = {}) => {
    try {
      return await api.get(
        `${adminPath}/export${queryBuilder({
          ...filters
        })}`
      )
    } catch (error) {
      return handleError(error)(error)
    }
  }
  
  const exportReservedAssets = async (data = []) => {
    try {
      return await api.post(`${adminPath}/export-reserved-assets`, data)
    } catch (error) {
      return handleError(error)(error)
    }
  }

  return {
    Admin: {
      writeNote,
      updateNote,
      getNotes,
      exportExcel,
      exportReservedAssets
    }
  }
}
</script>
